import { placesManagementLoadAction } from 'places-fwk-actions';
import { lazyPlacesManagementModule } from 'places-space-management';
import type { LoaderFunction } from 'react-router-dom';
import {
    canAccessManagementPage,
    checkIfCanAccessManagementPage,
} from 'places-management-permission';

export const ManagementLoader: LoaderFunction = async () => {
    placesManagementLoadAction({ scenario: 'PlacesManagementLoadStart' });

    const checkPermission = async () => {
        const resultFromCache = canAccessManagementPage();
        if (resultFromCache == null) {
            // If the permission check returns null, we need to perform an async check
            const resultFromApi = await checkIfCanAccessManagementPage();
            placesManagementLoadAction({
                scenario: resultFromApi == null ? 'PermissionCheckFailed' : 'PermissionChecked',
            });
        } else {
            placesManagementLoadAction({
                scenario: 'PermissionCheckFromCache',
            });
        }
    };

    // Define critical data: places management module and check permission
    const criticalData = [
        lazyPlacesManagementModule.import().then(() => {
            placesManagementLoadAction({
                scenario: 'BundleLoaded',
            });
        }),
        checkPermission(),
    ];

    return Promise.all(criticalData);
};
